import { VENUE } from '../constants/seo';

export const buildEventJsonLd = (events = []) =>
    events
        .filter((event) => event?.start && event?.title)
        .map((event) => ({
            '@context': 'https://schema.org',
            '@type': 'Event',
            name: event.title,
            startDate: event.start,
            endDate: event.end || undefined,
            eventStatus: 'https://schema.org/EventScheduled',
            eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
            location: {
                '@type': 'Place',
                name: event.location || VENUE.name,
                address: VENUE.address,
            },
        }));

export const injectJsonLd = (jsonObject, id) => {
    if (typeof document === 'undefined') {
        return;
    }
    let script = document.getElementById(id);
    if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(jsonObject);
};

export const clearJsonLd = (id) => {
    if (typeof document === 'undefined') {
        return;
    }
    const script = document.getElementById(id);
    if (script) {
        script.remove();
    }
};
